import { defineComponent } from 'vue';
export default defineComponent({
  name: 'CButton',
  props: {
    msg: String
  }
});